'use strict';

var firebase = require('firebase-legacy/app').default;
require('firebase-legacy/auth');
require('firebase-legacy/functions');
var log = require('../log/Log').channel('KayleeBase');

var firebaseConfig = {
    ariel: {
        apiKey: 'AIzaSyBv4clsxRMECOiDK-4sI-ZDWI5lD9Altsk',
        authDomain: 'ariel-a5cb0.firebaseapp.com',
        databaseURL: 'https://ariel-a5cb0.firebaseio.com',
        projectId: 'ariel-a5cb0',
        storageBucket: 'ariel-a5cb0.appspot.com',
        messagingSenderId: '346171314754',
        // remoteAuthURL: TBD
    },
    haven: {
        apiKey: 'AIzaSyCEybvhrtH6ChsDDmPz3RYyxC2QjWCuElM',
        authDomain: 'haven-addcd.firebaseapp.com',
        databaseURL: 'https://haven-addcd.firebaseio.com',
        projectId: 'haven-addcd',
        storageBucket: 'haven-addcd.appspot.com',
        messagingSenderId: '19290934635',
        // remoteAuthURL: TBD
    },
    higgins: {
        apiKey: 'AIzaSyBaPCNYOv1AwPYpfu2URHWkQWyLypLrlIc',
        authDomain: 'higgins-d729f.firebaseapp.com',
        databaseURL: 'https://higgins-d729f.firebaseio.com',
        projectId: 'higgins-d729f',
        storageBucket: 'higgins-d729f.appspot.com',
        messagingSenderId: '763750041628',
        // remoteAuthURL: TBD
    },
    persephone: {
        apiKey: 'AIzaSyCAyKNL1v6X_4zT9SnFtCY9Eg1dbMikcsA',
        authDomain: 'persephone.firebaseapp.com',
        databaseURL: 'https://persephone.firebaseio.com',
        projectId: 'project-7272607488869041933',
        storageBucket: 'project-7272607488869041933.appspot.com',
        messagingSenderId: '218162888751',
        remoteAuthURL: 'https://persephone-remote-auth.firebaseapp.com',
    },
    serenity: {
        apiKey: 'AIzaSyCg-5hWU0dFYKFfxvXdgY3ohz9qkXcQuX4',
        authDomain: 'serenity-eace1.firebaseapp.com',
        databaseURL: 'https://serenity-eace1.firebaseio.com',
        projectId: 'serenity-eace1',
        storageBucket: 'serenity-eace1.appspot.com',
        messagingSenderId: '775555189405',
        remoteAuthURL: 'https://miraconnect.me',
    },
};

var firebaseConsoleUrlBase = 'https://console.firebase.google.com/project/';

var functions = null;
var authStateChangedListeners = [];
var currentUser = null;

var KayleeBase = {
    alias: null,
    aliases: function() { return Object.keys(firebaseConfig); },
    app: null,
    config: firebaseConfig,
    getAuthDomain: getAuthDomain,
    getFirebaseConsoleUrl: getFirebaseConsoleUrl,
    getNewKey: getNewKey,
    getProjectId: getProjectId,
    getRemoteAuthUrl: getRemoteAuthUrl,
    getWebhookBaseAddress: getWebhookBaseAddress,
    initialize: initialize,
    isBrowser: isBrowser,
    isDbRoleEnabled: false,
    isInaraUserId: isInaraUserId,
    onAuthStateChanged: onAuthStateChanged,
    request: request,
    update: update,
};

function authStateChangedHandler(user) {
    currentUser = user;

    if (user === null) {
        log.info('unauthenticated');
    } else {
        var userString = '';

        if (typeof user.email !== 'undefined' &&
            user.email !== null && user.email !== '') {
            userString += '<' + user.email + '> ';
        }

        userString += '(' + user.uid + ')';

        log.info('authenticated ' + userString);
    }

    notifyAuthStateChangedListeners(user);
}

function notifyAuthStateChangedListeners(user) {
    for (var i = 0; i < authStateChangedListeners.length; i++) {
        var listener = authStateChangedListeners[i];

        if (listener.context) {
            listener.callback.call(listener.context, user);
        } else {
            listener.callback(user);
        }
    }
}

function onAuthStateChanged(callback, context) {
    var listener = { callback: callback, context: context };

    authStateChangedListeners.push(listener);

    if (listener.context) {
        listener.callback.call(listener.context, currentUser);
    } else {
        listener.callback(currentUser);
    }
}

function getAuthDomain() {
    if (KayleeBase.alias === null) {
        log.error('No Firebase alias set - cannot determine authDomain');
        return;
    }

    if (!firebaseConfig[KayleeBase.alias].hasOwnProperty('authDomain')) {
        log.error('The firebaseConfig does not contain an authDomain definition.');
        return;
    }

    return firebaseConfig[KayleeBase.alias].authDomain;
}

function getFirebaseConsoleUrl(firebaseObject, pathSuffix) {
    var url = firebaseConsoleUrlBase + getProjectId() + '/database/' +
        getAuthDomain().split('.')[0] + '/data/';
    if (typeof firebaseObject !== 'undefined' &&
        firebaseObject !== null) {
        // get a relative ref string
        url = url + '~2F' + firebaseObject.$getRefString(true).replaceAll('/', '~2F');
        if (typeof pathSuffix !== 'undefined') {
            url = url + '~2F' + pathSuffix.replaceAll('/', '~2F');
        }
    }
    return url;
}

function getNewKey() {
    return KayleeBase.app.database().ref().push().key;
}

function getProjectId() {
    // This function determines the Firebase projectID by parsing the storage
    // bucket info configured in firebaseConfig.
    if (KayleeBase.alias === null) {
        log.error('No Firebase alias set - cannot determine project ID');
        return;
    }

    if (!firebaseConfig[KayleeBase.alias].hasOwnProperty('projectId')) {
        log.error('The firebaseConfig does not contain a projectId definition.');
        return;
    }

    return firebaseConfig[KayleeBase.alias].projectId;
}

function getRemoteAuthUrl() {
    if (KayleeBase.alias === null) {
        log.error('No Firebase alias set - cannot determine project ID');
        return;
    }

    if (!firebaseConfig[KayleeBase.alias].hasOwnProperty('remoteAuthURL')) {
        log.error('The firebaseConfig does not contain a remoteAuthURL definition.');
        return;
    }

    return firebaseConfig[KayleeBase.alias].remoteAuthURL;    
}

function getWebhookBaseAddress() {
    return 'https://us-central1-' +
        firebaseConfig[KayleeBase.alias].projectId +
        '.cloudfunctions.net';
}

function initialize(alias) {
    if (typeof alias === 'object' && !alias.hasOwnProperty('projectId')) {
        return initializeCloudFunctions(alias);
    }

    if (typeof alias === 'object' && alias.hasOwnProperty('projectId')) {
        return initializeServerAdmin(alias);
    }

    log.debug('initializing app to: ' + alias);

    KayleeBase.alias = alias;
    KayleeBase.app =
        firebase.initializeApp(firebaseConfig[alias], 'kaylee');

    functions = firebase.functions(KayleeBase.app);

    KayleeBase.app.auth().onAuthStateChanged(authStateChangedHandler, function(err) {
        log.info('authentication error: ' + err);
    });
}

function initializeCloudFunctions(serviceAccounts) {
    var adminConfig = JSON.parse(process.env.FIREBASE_CONFIG);

    if (!adminConfig.hasOwnProperty('projectId')) {
        log.error('admin config object does not have projectId property');
        return;
    }

    for (var alias in firebaseConfig) {
        if (!firebaseConfig.hasOwnProperty(alias)) continue;
        var cfg = firebaseConfig[alias];
        if (cfg.projectId === adminConfig.projectId) {
            if (!serviceAccounts.hasOwnProperty(alias)) {
                log.error('no service account definition for: ' + alias);
                return;
            }

            log.info('initializing app to: ' + alias + ' (' + cfg.projectId + ')');

            KayleeBase.alias = alias;
            log.debug('process.env.FIREBASE_CONFIG = ' + JSON.stringify(process.env.FIREBASE_CONFIG, null, 4));
            log.debug('cert = ' + JSON.stringify(serviceAccounts[alias], null, 4));
            KayleeBase.app = firebase.initializeApp({
                credential: firebase.credential.cert(serviceAccounts[alias]),
                databaseURL: cfg.databaseURL,
                databaseAuthVariableOverride: {
                    uid: 'jayne',
                },
            });

            return;
        }
    }

    log.error('no alias found for projectId = ' + adminConfig.projectId);
}

function initializeServerAdmin(serviceCredentials) {
    KayleeBase.alias = getAliasFromProjectId(serviceCredentials.projectId);

    log.info('initializing to ' + KayleeBase.alias);

    KayleeBase.app = firebase.initializeApp({
        credential: firebase.credential.cert(serviceCredentials),
        databaseURL: firebaseConfig[KayleeBase.alias].databaseURL,
    });
}

function getAliasFromProjectId(projectId) {
    for (var alias in firebaseConfig) {
        if (!firebaseConfig.hasOwnProperty(alias)) continue;
        var cfg = firebaseConfig[alias];
        if (cfg.projectId === projectId) return alias;
    }

    return null;
}

function isBrowser() {
    return typeof window !== 'undefined' && typeof window.document !== 'undefined';
}

function isInaraUserId(userId) {
    // Inara's user IDs are all firebaseIDs, which are exactly 20 characters
    // long. Mal userIDs are firebase auth user IDs, which are 28 characters
    // long. The anonymous remote control user's ID is
    // "anonymousRemoteControl".

    return userId.length === 20;
}

function request(name, data, logError) {
    if (typeof logError === 'undefined') logError = true;
    var timestamp = Date.now();

    return functions.httpsCallable(name)(data)
    .then(function(resp) {
        if (resp.hasOwnProperty('data')) return resp.data;
        log.error('unexpected response format: ' + JSON.stringify(resp, null, 4));
        return resp;
    })
    .catch(function(error) {
        if (logError) {
            var message = name + ' error; code: ' + error.code;
            if (error.message) message += ', message: ' + error.message;
            if (error.details) message += ', details: ' + error.details;
            message += ', from request at ' + (new Date(timestamp)).toLocaleString();
            log.error(message);
        }

        return Promise.reject(error);
    });
}

// Running all database reference .update() calls through this function makes it
// easier to debug (setting breakpoints, printing debugging messages, etc.) when
// there are "permission denied" errors from the security rules.

function update(pathOrUpdates, updates, logUpdateOnError) {
    var ref;

    if (updates) {
        ref = KayleeBase.app.database().ref(pathOrUpdates);
    } else {
        ref = KayleeBase.app.database().ref();
        updates = pathOrUpdates;
    }

    return ref.update(updates)
    .then(function() {
        return Promise.resolve();
    }, function(err) {
        log.debug('update = ' + JSON.stringify(updates, null, 4));
        log.error('update failed, error: ' + err);
        return Promise.reject(err);
    });
}

module.exports = KayleeBase;
